/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_N8nInputs */



/**
* | output |
* | --- |
* | "Workflows and executions from your automation hub." |
*
* @param {Spaces_Gallery_Desc_N8nInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_n8n = /** @type {((inputs?: Spaces_Gallery_Desc_N8nInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_N8nInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Workflows und Ausführungen aus deiner Automatisierung.")
	return /** @type {LocalizedString} */ ("Workflows and executions from your automation hub.")
});